import { type CountryCode } from 'libphonenumber-js'
import { type IRcsCountryCode } from 'entities/Rcs'
import { RCS_SUPPORTED_COUNTRIES } from './constants'

export const toRcsCountryCode = (code: CountryCode): IRcsCountryCode | undefined =>
  RCS_SUPPORTED_COUNTRIES.find((country) => country.isoCode === code)?.rcsCode

export const toIsoCountryCode = (rcsCode: string): CountryCode | undefined =>
  RCS_SUPPORTED_COUNTRIES.find((country) => country.rcsCode === rcsCode)?.isoCode
